import { CART_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { IHDCartAddressListResponse } from "@/api_framework/api_modals/Cart";

AxiosCurlirize(axios, () => {});
export const useAddressUpdateOnSlotAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();
  const execute = useCallback(
    async (userId: string, address?: any) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const res: AxiosResponse<IHDCartAddressListResponse> = await axios.post(
          `${CART_MODULE?.ADDRESS_STORE?.baseURL}`,
          {
            user_id: userId,
            address: address,
          },
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );

        if (res.data.status === true) {
          //
          return res.data.data;
        } else {
          //
          return [];
        }
      } catch (e: any) {
        if (axios.isAxiosError(e) && e.config) {
          sendCurl(e.config["curlCommand"]);
        }
        // captureError(e);
        // toast.error("Server Error: " + e.message);
        return [];
      }
    },
    [dispatch, configuration, captureError, sendCurl],
  );
  return execute;
};
